// ModalComponent.js
import React, { useRef, useEffect } from 'react';
import iziModal from 'izimodal';

const ModalComponent = ({ isOpen, closeModal, iframeSrc }) => {
    const modalRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            // Initialize the iziModal when the modal is open
            modalRef.current = iziModal({
                iframe: true,
                iframeURL: iframeSrc,
                onClosed: closeModal,
            });

            modalRef.current.iziModal('open');
        }

        // Cleanup iziModal instance on component unmount or when modal is closed
        return () => {
            if (modalRef.current) {
                modalRef.current.iziModal('destroy');
            }
        };
    }, [isOpen, closeModal, iframeSrc]);

    return <div />;
};

export default ModalComponent;



// WEBPACK FOOTER //
// ./src/view_components/ModalComponent.js